<template>
  <p class="text-sm mt-4">Markieren Sie diese Firma:</p>
  <div class="mt-1">
    <button @click="storeProfessional(1)" class="btn btn-sm m-1" :class="formdata.professional === 1 ? 'btn-green' : 'btn-secondary'">Professionell</button>
    <button @click="storeProfessional(0)" class="btn btn-sm m-1" :class="formdata.professional === 0 ? 'btn-green' : 'btn-secondary'">Unprofessionell</button>
    <button @click="storePrice(0)" class="btn btn-sm m-1" :class="formdata.price === 0 ? 'btn-green' : 'btn-secondary'">Dumpingpreis</button>
    <button @click="storePrice(1)" class="btn btn-sm m-1" :class="formdata.price === 1 ? 'btn-green' : 'btn-secondary'">Fairer Preis</button>
    <button @click="storePrice(2)" class="btn btn-sm m-1" :class="formdata.price === 2 ? 'btn-green' : 'btn-secondary'">Zu teuer</button>
    <button @click="storeKindness(1)" class="btn btn-sm m-1" :class="formdata.kindness === 1 ? 'btn-green' : 'btn-secondary'">Freundlich</button>
    <button @click="storeKindness(0)" class="btn btn-sm m-1" :class="formdata.kindness === 0 ? 'btn-green' : 'btn-secondary'">Unfreundlich</button>
    <button @click="storeActive(1)" class="btn btn-sm m-1" :class="formdata.active === 1 ? 'btn-green' : 'btn-secondary'">Interesse am Auftrag</button>
    <button @click="storeActive(0)" class="btn btn-sm m-1" :class="formdata.active === 0 ? 'btn-green' : 'btn-secondary'">Wenig Interesse</button>
  </div>
  <p class="mt-2 text-xs">Ihre Markierung bleibt <strong>anonym</strong>. Sie hilft uns bei unserer Vermittlung und wir geben den Firmen gezielte Tipps, wie sie sich verbessern können.</p>
</template>

<script>
import companyApi from '../../connections/company';
import store from '../../store/mainStore';

export default {
  name: 'CompanyTags',
  created() {
    if(!this.companyTag) {
      this.formdata.company_id = this.companyLead.company_id;
      this.formdata.lead_id = this.companyLead.lead_id;
    } else {
      this.formdata = {};
      Object.assign(this.formdata, this.companyTag)
    }
  },
  props: {
    companyLead: Object,
    companyTag: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      formdata: {
        professional: null,
        price: null,
        kindness: null,
        active: null,
      }

    };
  },
  methods: {
    storeProfessional(value) {
      this.formdata.professional = value;
      this.storeData()
    },
    storePrice(value) {
      this.formdata.price = value;
      this.storeData()
    },
    storeKindness(value) {
      this.formdata.kindness = value;
      this.storeData()
    },
    storeActive(value) {
      this.formdata.active = value;
      this.storeData()
    },
    storeData() {
      if(this.formdata.hasOwnProperty('id')) {
        companyApi.patch('companies/' + this.companyLead.company_id + '/company-tags/' + this.formdata.id, this.formdata, { notification: false, progress: true }).
            then(response => response.data.notificationType === 'success' ?
                [store.dispatch('customer/updateCompanyTag', response.data.content)] : '');
      } else {
      companyApi.post('companies/' + this.companyLead.company_id + '/company-tags', this.formdata, { notification: false, progress: true }).
          then(response => response.data.notificationType === 'success' ?
              [store.dispatch('customer/updateCompanyTag', response.data.content), Object.assign(this.formdata, response.data.content)] : '');
      }
    }
  },
};
</script>

<style scoped>

</style>